<div class="delete-entity-toast" preventWindowUnloading *ngIf="label">
  <p class="message">
    {{ label }}
  </p>

  <div class="actions">
    <button
      type="button"
      class="action undo-action"
      (click)="undoDeleteEntity()"
    >
      {{ 'ACTION.UNDO' | translate }}
    </button>

    <button type="button" class="action close-action">
      <span class="sr-text">
        {{ 'ACTION.CLOSE' | translate }}
      </span>

      <app-icon [icon]="closeIcon"></app-icon>
    </button>
  </div>
</div>
